import { useState } from "react";
import { MessageSquare, Send, Loader2, CheckCircle2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";
import { PhotoPicker } from "@/components/PhotoPicker";

export function AskDev({ compact = false, testid = "ask-dev-open" }) {
  const { t } = useLang();
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ email: user?.email || "", name: user?.name || "", message: "" });
  const [state, setState] = useState("idle");
  const [err, setErr] = useState("");
  const [photos, setPhotos] = useState([]);
  const [uploading, setUploading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setState("busy"); setErr("");
    try { await api.ask({ ...form, photo_ids: photos.map((p) => p.id) }); window.dispatchEvent(new Event("questions-changed")); setState("sent"); setForm({ ...form, message: "" }); setPhotos([]); }
    catch (e2) { setErr(apiError(e2) || t("Something went wrong. Try again.")); setState("idle"); }
  };

  return (
    <>
      <button type="button" className={compact ? "ask-dev-chip" : "primary-btn secondary-btn"} data-testid={testid} aria-label={t("Ask the developer")}
        onClick={(e) => { e.stopPropagation(); setForm((f) => ({ ...f, email: f.email || user?.email || "", name: f.name || user?.name || "" })); setOpen(true); setState("idle"); }}>
        <MessageSquare size={16} />{compact ? t("Ask dev") : t("Ask the developer")}
      </button>
      {open && (
        <div className="modal-backdrop ask-dev-backdrop" onClick={(e) => { e.stopPropagation(); setOpen(false); }}>
          <form className="modal" onClick={(e) => e.stopPropagation()} onSubmit={submit} data-testid="ask-dev-modal">
            <div className="card-name">{t("Ask the developer")}</div>
            {state === "sent" ? (
              <div className="ask-sent" data-testid="ask-dev-sent"><CheckCircle2 size={20} />{t("Sent! You'll get a reply at {e}.", { e: form.email })}</div>
            ) : (
              <>
                <div className="card-sub">{t("Questions, bugs or ideas. The reply comes to your email.")}</div>
                <input className="text-input" data-testid="ask-dev-email" type="email" required placeholder={t("Your email")} value={form.email} onChange={set("email")} />
                <textarea className="text-input ask-text" data-testid="ask-dev-message" required minLength={3} maxLength={2000}
                  placeholder={t("Your question")} value={form.message} onChange={set("message")} />
                <PhotoPicker photos={photos} setPhotos={setPhotos} setUploading={setUploading} t={t} testid="ask-dev" />
                {err && <div className="form-error" data-testid="ask-dev-error">{err}</div>}
              </>
            )}
            <div className="modal-actions">
              <button type="button" className="ghost-btn" data-testid="ask-dev-close" onClick={() => setOpen(false)}>{t("Close")}</button>
              {state !== "sent" && (
                <button type="submit" className="primary-btn" data-testid="ask-dev-send" disabled={state === "busy" || uploading}>
                  {state === "busy" ? <Loader2 size={16} className="spin" /> : <Send size={16} />}{t("Send")}
                </button>
              )}
            </div>
          </form>
        </div>
      )}
    </>
  );
}
